import { ReactElement, useMemo, useState } from 'react';
import { Tooltip as BaseTooltip } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';

interface Props {
  title: string | ReactElement;
  children: ReactElement;
  defaultOpen?: boolean;
  className?: string;
}

export default function Tooltip(props: Props): ReactElement {
  const { title, children, defaultOpen, className } = props;

  const [open, setOpen] = useState(defaultOpen ?? false);

  function onClose(): void {
    setOpen(false);
  }

  return useMemo(
    () => (
      <ClickAwayListener onClickAway={onClose}>
        <BaseTooltip
          title={title}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={onClose}
          className={className}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          arrow
          placement="top"
          slotProps={{
            popper: {
              disablePortal: true,
            },
          }}
          classes={{
            popper: '!px-xs !w-full !z-[40]',
            tooltip:
              '!w-full !max-w-full !mb-xs !bg-white !rounded-md !shadow dark:shadow-none !border !text-brand-text-primary !text-xs !font-normal',
            arrow: '!text-white',
          }}
        >
          <button onClick={() => setOpen(true)}>{children}</button>
        </BaseTooltip>
      </ClickAwayListener>
    ),
    [title, open, children, className],
  );
}
